// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-195661ca] .bj-page .el-form-item__label {\n  display: none;\n}\n.el-icon-s-flag[data-v-195661ca] {\n  float: right;\n  line-height: 34px;\n}", ""]);
// Exports
module.exports = exports;
